import React, { FC } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import useContentful from "./hooks/useContentful";
import contentfulComponentLoop from "./lib/contentfulComponentLoop";
import { ModalContextProvider } from "./contexts/ModalContext";

const Container = styled.div`
  padding-top: 38px;
`;

const Index: FC = () => {
  const contentfulDiv = document.getElementById('contentful');
  const entryId = contentfulDiv?.dataset.entryId;
  const localeDiv = document.getElementById('shopify-locale-target');
  let localeString = localeDiv?.dataset.shopLocale;
  if (!localeString || localeString == 'en') {
    localeString = 'en-US';
  }
  const { contentfulData } = useContentful({ include: 10, 'sys.id': entryId, locale: localeString });

  if (contentfulData) {
    return (
      <ModalContextProvider>
        <Container>
          {contentfulComponentLoop(contentfulData?.items[0].fields?.components)}
        </Container>
      </ModalContextProvider>
    );
  }

  return <div>standby</div>;
};

ReactDOM.render(<Index />, document.getElementById('contact-react'));